import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex-shrink-0">
            <Link to="/">
              <img 
                src="https://public.readdy.ai/ai/img_res/8fe0d364-fcb5-4173-8f6a-51a7283c7d3a.png" 
                alt="ClearPath Consulting" 
                className="h-36"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a 
              href="https://www.clearpathconsulting-global.com" 
              className={`text-2xl font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-sky-600' 
                  : 'text-white hover:text-sky-300'
              }`}
            >
              Home
            </a>
            <Link 
              to="/services" 
              className={`text-2xl font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/services'
                  ? 'text-sky-600'
                  : isScrolled || !isHomePage 
                    ? 'text-gray-900 hover:text-sky-600' 
                    : 'text-white hover:text-sky-300'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`text-2xl font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-sky-600'
                  : isScrolled || !isHomePage 
                    ? 'text-gray-900 hover:text-sky-600' 
                    : 'text-white hover:text-sky-300'
              }`}
            >
              About Us
            </Link>
            <Link 
              to="/careers" 
              className={`text-2xl font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/careers'
                  ? 'text-sky-600'
                  : isScrolled || !isHomePage 
                    ? 'text-gray-900 hover:text-sky-600' 
                    : 'text-white hover:text-sky-300'
              }`}
            >
              Careers
            </Link>
            <Link 
              to="/contact" 
              className={`text-2xl font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/contact'
                  ? 'text-sky-600'
                  : isScrolled || !isHomePage 
                    ? 'text-gray-900 hover:text-sky-600' 
                    : 'text-white hover:text-sky-300'
              }`}
            >
              Contact Us
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-8 h-8 flex items-center justify-center"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <nav className="px-6 py-4 space-y-3">
            <a 
              href="https://www.clearpathconsulting-global.com" 
              className="block text-2xl font-medium text-gray-900 hover:text-sky-600 whitespace-nowrap"
            >
              Home
            </a>
            <Link 
              to="/services" 
              className={`block text-2xl font-medium whitespace-nowrap ${
                location.pathname === '/services' ? 'text-sky-600' : 'text-gray-900 hover:text-sky-600'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`block text-2xl font-medium whitespace-nowrap ${
                location.pathname === '/about' ? 'text-sky-600' : 'text-gray-900 hover:text-sky-600'
              }`}
            >
              About Us
            </Link>
            <Link 
              to="/careers" 
              className={`block text-2xl font-medium whitespace-nowrap ${
                location.pathname === '/careers' ? 'text-sky-600' : 'text-gray-900 hover:text-sky-600'
              }`}
            >
              Careers
            </Link>
            <Link 
              to="/contact" 
              className={`block text-2xl font-medium whitespace-nowrap ${
                location.pathname === '/contact' ? 'text-sky-600' : 'text-gray-900 hover:text-sky-600'
              }`}
            >
              Contact Us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
